import getLocalizedName from '@/utils/getLocalizedName'

export function getFormattedName ({ surname, name, middleName }) {
  const fullName = [surname, name, middleName].map(item => getLocalizedName(item))
  const o = {
    surname: fullName[0],
    name: fullName[1] && fullName[1][0].toUpperCase() + '.',
    middleName: fullName[2] && fullName[2][0].toUpperCase() + '.'
  }
  return `${o.surname} ${o.name} ${o.middleName}`.trim()
}

export function getFullName ({ surname, name, middleName }) {
  const fullName = [surname, name, middleName].map(item => getLocalizedName(item))
  return fullName.join(' ').trim()
}
